import { HubspotTicketStatusTypes, HubspotTicketUrgencyTypes } from './hubspot.ticket.item';

export class HubspotTicketWidgetItem {

    TicketID: number;
    HubspotID: number;
    AdminID: number;
    AdminName: string;
    MemberID: number;
    MemberName: string;
    DueDate: Date;
    DateTimeCreated: Date;
    Subject: string;
    Body: string;
    Status: HubspotTicketStatusTypes;
    Urgency: HubspotTicketUrgencyTypes;

    public static FixDates(item: HubspotTicketWidgetItem) {

        if (item.DueDate != undefined && item.DueDate != null)
            item.DueDate = new Date(item.DueDate);

        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }
}

export class HubspotTicketWidgetItemArray extends Array<HubspotTicketWidgetItem> {

    constructor(...items: HubspotTicketWidgetItem[]) {
        super(...items);
        Object.setPrototypeOf(this, HubspotTicketWidgetItemArray.prototype);
    }

    public static FixDates(items: HubspotTicketWidgetItemArray) {
        items.forEach(x => HubspotTicketWidgetItem.FixDates(x));
    }

}
